const filtersType = [
  {
    label: 'Imagem',
    value: 'image',
  },
  {
    label: 'Texto',
    value: 'text',
  },
];

export default filtersType;
